var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphingMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:3;}\n\t.st2{fill:transparent;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 50,
    height: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 23.5,
    className: "st0",
    width: 37.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 7,
    className: "st0",
    width: 3,
    height: 36
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.1,11.5c0,2.2,0.8,27.1,7.5,26.9c8.2-0.2,11-26.9,17.7-26.9c5.4,0,8.7,18.1,8.7,26.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphingMode);
export default __webpack_public_path__ + "static/media/graphing_mode.c7c7dca7dd6a7a4067cc3b1660039c60.svg";
export { ForwardRef as ReactComponent };